import ExcelResponse from '@/types/app/excelResponse';
import ProductInterface from '@/types/app/products';
import ProductExcel from '@/types/app/productsExcel';
import Endpoint from '@/utils/endpoint';
import { saveFile } from '@/utils/saveFile';
import { AxiosInstance } from 'axios';
import moment from 'moment';
import { ActionContext } from 'vuex';
import { ProductExcelStateInterface } from './types';

moment.locale('en-US');
export default {
  async importProductsFromExcel(
    store: ActionContext<ProductExcelStateInterface, any>,
    data: { file: Blob; http: AxiosInstance }
  ): Promise<ExcelResponse> {
    const endpoint = new Endpoint();

    return await saveFile(endpoint.saveProductsExcelFile, data.file, data.http);
  },

  setIsSavingFile(
    store: ActionContext<ProductExcelStateInterface, any>,
    saving: boolean
  ): void {
    store.commit('setIsSavingFile', saving);
  },

  setProductsToExcel(
    store: ActionContext<ProductExcelStateInterface, any>,
    products: ProductExcel[]
  ): void {
    store.commit('setProductsToExcel', products);
  },

  setIsExportingFile(
    store: ActionContext<ProductExcelStateInterface, any>,
    exporting: boolean
  ): void {
    store.commit('setIsExportingFile', exporting);
  },

  async getProductsExcelFile(
    store: ActionContext<ProductExcelStateInterface, any>,
    data: { products: ProductExcel[]; http: AxiosInstance }
  ): Promise<string> {
    let response;
    const endpoint = new Endpoint().exportProductsAsExcel;

    const http = data.http;
    try {
      response = await http.post(endpoint, data.products);
      const result = response as any;

      if (!result.hasErrors) {
        const byteCharacters = atob(result.data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const url = URL.createObjectURL(
          new Blob([byteArray], {
            type: 'application/vnd.ms-excel'
          })
        );

        return url;
      } else {
        return '';
      }
    } catch (e) {
      console.error(e);
      return Promise.reject();
    }
  },

  convertToProductExcel(
    store: ActionContext<ProductExcelStateInterface, any>,
    product: ProductInterface
  ): ProductExcel {
    const productExcel: ProductExcel = {
      id: product.id,
      fundId: product.fundId,
      title: product.title,
      description: product.description,
      summary: product.summary,
      fees: product.fees,
      created: product.created,
      targetFundSize: product.targetFundSize,
      minimalInvestment: product.minimalInvestment,
      maturity: product.maturity,
      deadline: product.deadline ?? '',
      domicile: product.domicile,
      unity: product.unity,
      area: product.area,
      status: product.status,
      shareClass: product.shareClass,
      targetIrr: product.targetIrr,
      targetDividend: product.targetDividend,
      investmentVehicle: product.investmentVehicle,
      targetSize: product.targetSize,
      targetYield: product.targetYield,
      expectedTerm: product.expectedTerm,
      strategyAUM: product.strategyAUM,
      ytdPerformance: product.ytdPerformance,
      lastMonthPerformance: product.lastMonthPerformance,
      raised: product.raised,
      irr: product.irr,
      cashYield: product.cashYield,
      size: product.size,
      investorType: product.investorType,
      published: product.published,
      returnSinceInception: product.returnSinceInception,
      aum: product.aum,
      inceptionDate: product.inceptionDate ?? '',
      committedCapital: product.committedCapital,
      showCard: product.showCard,
      performanceFee: product.performanceFee,
      managementFee: product.managementFee
    };
    return productExcel;
  }
};
